import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import LabOffering from "@/pages/LabOffering";

export const Route = createFileRoute("/zh-cn/services/lab-services/microbiological-analysis")({
  head: () => buildRouteHead("/zh-cn/services/lab-services/microbiological-analysis"),
  component: LabOffering,
});

